var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLegendBuilderYesNoi = function SvgLegendBuilderYesNoi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: props.color || 'currentColor',
    rx: 2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Yes/No"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    "data-name": "Ellipse 171",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6a6 6 0 0 1 6 6 6 6 0 0 1-6 6z",
    "data-name": "Intersection 1"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLegendBuilderYesNoi);
export default ForwardRef;